import { render, staticRenderFns } from "./ConfirmTemplate.vue?vue&type=template&id=3f28ad96"
import script from "./ConfirmTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports